import React from "react";

import LinearProgress from '@material-ui/core/LinearProgress';
import { NavLink } from "react-router-dom";

import mtzApis from "../../../../services";

const { companyService } = mtzApis;

export default function CompanyProfileCompletion({ progressOnly }) {
    let [profilePercent, setProfilePercent] = React.useState(null);
    let [showAlert, setShowAlert] = React.useState(false);
    let [company, setCompany] = React.useState(null);
    const params = new URLSearchParams(window.location.search);
    const todoProfileComplete = params.get("todo-complete-profile") || false;

    React.useEffect(() => {
        (async () => {
            company = await companyService.getMyCompany();
            setCompany(company || '');
            if (company) {
                let completionPoints = await companyService.getCoProfilePercents(new URLSearchParams(`companyIds=${company.id}`));
                if (!!completionPoints && completionPoints.length > 0) {
                    const completion = completionPoints[0];
                    setProfilePercent(completion);
                    showAlert = completion.completionPercent !== 1;
                    setShowAlert(showAlert);
                }
            }
        })();
    }, []);

    return (
        <>
            {
                !!profilePercent && profilePercent.completionPercent !== 1 &&
                <div className='alert alert-danger w-100' style={{ boxShadow: '2px 2px 2px' }} id="profileCompletion">
                    <div id="todo-complete-profile">
                        <div className="btn w-100" data-toggle="collapse" data-target="#profileComplete">
                            <span className="fa fa-warning"></span>&nbsp;
                            Warning: Your company profile is not visible on the search results! To be visible on the search results, please complete your profile. It only takes few minutes.&nbsp;
                            <span className="fa fa-caret-down"></span>

                        </div>

                        <div id="profileComplete" className="collapse" data-parent="#profileCompletion">
                            <div className="w-100">
                                {company === null && <div>Loading...</div>}

                                {company !== null && !company && <span>Click <NavLink to="/me/company">&nbsp;HERE&nbsp;</NavLink> to create company.</span >}

                                {company && showAlert &&
                                    <div>
                                        <div>
                                            <small><b>Profile completed {(profilePercent && Math.round(profilePercent.completionPercent * 100)) || 0}%</b></small>
                                            <LinearProgress variant="determinate" value={profilePercent && Math.round(profilePercent.completionPercent * 100)} />
                                        </div>
                                        <br />
                                        {
                                            !progressOnly && showAlert &&
                                            <ul>
                                                {profilePercent.logoPoint === 0 && <AlertMessage message="Upload Logo" link={`/profile/${company.profileName}##mtz-company-logo##`} />}
                                                {profilePercent.bannerPoint === 0 && <AlertMessage message="Upload Banner" link={`/profile/${company.profileName}##mtz-company-banner##`} />}
                                                {profilePercent.summaryPoint === 0 && <AlertMessage message="Add Company Summary" link={`/profile/${company.profileName}?selectedDialog=COMPANY_DETAILS`} />}
                                                {profilePercent.descriptionPoint === 0 && <AlertMessage message="Add Company Description" link={`/profile/${company.profileName}?selectedDialog=COMPANY_DETAILS`} />}
                                                {profilePercent.categoryPoint === 0 && <AlertMessage message="Add Company Categories" link={`/profile/${company.profileName}##mtz-company-categories##`} />}
                                                {profilePercent.targetCategoryPoint === 0 && <AlertMessage message="Add Company Target Categories" link={`/profile/${company.profileName}##mtz-company-target-categories##`} />}
                                                {profilePercent.addressPoint === 0 && <AlertMessage message="Add Company Address" link={`/profile/${company.profileName}?selectedDialog=COMPANY_INFO`} />}
                                            </ul>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

function AlertMessage({ message, link }) {
    return (
        <li><NavLink target="_blank" to={link}>{message}</NavLink></li>
    );
}
